import React from 'react';
import { Button } from 'react-bootstrap';

export default function CalOptions(props) {

    var selectedCourse = props.selectedCourse; //[{"INFO 340": ["B", "BA"]}]
    var plans = props.plans;
    var setPlan = props.setPlan;
    var currPlan = props.currPlan;
    var setCourse = props.setCourse;
    var classInfo = props.classInfo;

    const changePlan = function () {
        let newPlan = plans.map((plan) => {
            if (plan.key === currPlan) {
                plan['plan'] = selectedCourse;
            }
            return plan
        })
        setPlan(newPlan);
    }

    const setCourseCallbackBeta = (code, newSelection) => {
        var newSelected = selectedCourse.map(singleCourse => {
            if(Object.keys(singleCourse)[0] === code) {
                // change singleCourse
                if (singleCourse[code].includes(newSelection)){
                    if (newSelection.length === 1) {
                        return {[code]: [0]}
                    }
                    else {
                        // section
                        var result = singleCourse[code].filter(e => e !== newSelection); 
                        return {[code]: result}
                    }
                }
                else {
                    //change selection
                    var resultAry = [];
                    if(newSelection.length === 1) {
                        // new one is lecture
                        resultAry.push(newSelection);
                        var targetClass = classInfo.filter(singleClass => Object.keys(singleClass)[0] === code)[0];
                        var targetLS = targetClass[code].filter(LSPair => Object.keys(LSPair["Lec"])[0] === newSelection)[0];
                        if (targetLS["Sec"].length !== 0) {
                            var targetSec = Object.keys(targetLS["Sec"][0])[0];
                            resultAry.push(targetSec);
                        }
                    }
                    else {
                        var noSec = true;
                        singleCourse[code].forEach(LS => {
                            if (LS.length === 2) {
                                noSec = false;
                                resultAry.push(newSelection)
                            }
                            else {
                                resultAry.push(LS)
                            }
                        })
                        if (noSec) {
                            resultAry.push(newSelection);
                        }
                    }
                    return {[code]: resultAry};
                }
            }
            return singleCourse;
        })
        setCourse(newSelected);
    }

    const deleteCourse = (code) => {
        setCourse(selectedCourse.filter((itm) => {
            return !Object.keys(itm).includes(code)
        }))
    }

    var courseChips = selectedCourse.map((singleClass, index) => {
        var singleClassCode = Object.keys(singleClass)[0] //INFO 340
        var singleTimeInfo = props.classInfo.filter(singleClassInfo => Object.keys(singleClassInfo).includes(singleClassCode))[0];
        var singleSelectedCourse = singleClass[singleClassCode];
        return <SingleCourse key={index} selectedLS={singleSelectedCourse} singleClass={singleTimeInfo} setCourseCallback={setCourseCallbackBeta} deleteCourse={deleteCourse}/>
    })
    
    return(
        <div className="calendar-options">
            <div className="calendar-titles">
                Select Courses
            </div>
            <div className="course-chips">
                {courseChips}
            </div>
            <div className="calendar-titles">
                Options
            </div>
            <button className="btn btn-outline-secondary" onClick={()=> {changePlan();}}>Save to Plan</button>
        </div>
    );
}

function SingleCourse(props) {
    var singleClass = props.singleClass;
            // {"INFO 340": [{"Lec": {"B": ["Tue-1730-110", "Thu-1730-110"]}, "Sec": [{"BA": ["Wed-1530-50"]}, {"BB": ["Wed-1630-50"]}]},
            // {"Lec": {"A": ["Tue-0830-110", "Thu-0830-110"]}, "Sec": [{"AA": ["Wed-1530-50"]}, {"AB": ["Tue-1630-50"]}]}]}
    var selectedLS = props.selectedLS; //["B", "BA"]
    var setCourseCallback = props.setCourseCallback;
    var deleteCourse = props.deleteCourse;
    var className = Object.keys(singleClass)[0];
    var classOptions = singleClass[className];
    var selectedSec = [];

    var LecBtns = classOptions.map((AllInfo) => {
        var LecInfo = AllInfo["Lec"];
        var LecChr = Object.keys(LecInfo)[0];
        var btnClass = "btn btn-outline-primary";
        var dataVal = LecInfo[LecChr];

        if (selectedLS.includes(LecChr)) {
            //Selected Lec
            btnClass = "btn btn-primary";
            selectedSec = AllInfo["Sec"];
        }
        return (
            <button type="button" className={btnClass} key={className + LecChr} onClick={() => {setCourseCallback(className, LecChr)}}>
                {className} <span className="badge bg-secondary">{LecChr}</span>
            </button>
        );    
    });

    var deleteBtn = (
        <div className='delete-div' key={-1}>
            <button className='course-delete btn btn-outline-secondary' onClick={() => {deleteCourse(className)}}>
                <span className="material-icons delete-icon">clear</span>
            </button>
        </div>
    );
    LecBtns.push(deleteBtn);


    var SecBtns = selectedSec.map((SecObj) => {
        var SecChr = Object.keys(SecObj)[0];
        var btnClass = "btn btn-outline-primary";
        var dataVal = SecObj[SecChr];
        if (selectedLS.includes(SecChr)) {
            //Selected Lec
            btnClass = "btn btn-primary";
        }
        return (
            <button type="button" className={btnClass} key={className + SecChr} onClick={() => {setCourseCallback(className, SecChr)}}>
                {SecChr}
            </button>
        );    
    });

    return (
        <div className="course-single">
            <div className="course-lecture">
                {LecBtns}
            </div>
            
            <div className={SecBtns.length == 0 ? "" : "course-section"}>
                {SecBtns}
            </div>
        </div>
    );
}
